import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
// Import only essential components matching design reference
import Navbar from '@/components/Navbar'
import Hero from '@/components/Hero'
import VisionDeck from '@/components/VisionDeck'

export default function Home() {
  const { user, isLoaded } = useUser()
  const navigate = useNavigate()
  const [showVision, setShowVision] = useState(false)

  useEffect(() => {
    if (isLoaded && user) {
      navigate('/dashboard')
    }
  }, [user, isLoaded, navigate])

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black">
        <div className="text-center space-y-4 animate-pulse">
          <div className="w-12 h-12 mx-auto bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
            <span className="text-white font-black text-xs">NP</span>
          </div>
          <p className="text-zinc-500 text-xs font-black uppercase tracking-widest">
            Loading...
          </p>
        </div>
      </div>
    )
  }

  return (
    <main className="relative min-h-screen bg-black text-white selection:bg-white/20 overflow-x-hidden">
      <Navbar onVisionClick={() => setShowVision(true)} />
      <Hero />
      
      {/* Vision Deck Modal */}
      {showVision && <VisionDeck onExit={() => setShowVision(false)} />}
    </main>
  )
}
